var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87695 11.877C9.09375 11.877 11.7539 9.2168 11.7539 6C11.7539 2.77734 9.09375 0.123047 5.87109 0.123047C2.6543 0.123047 0 2.77734 0 6C0 9.2168 2.66016 11.877 5.87695 11.877ZM5.87695 11.1152C3.04102 11.1152 0.761719 8.83008 0.761719 6C0.761719 3.16406 3.04102 0.878906 5.87109 0.878906C8.70703 0.878906 10.9922 3.16406 10.998 6C10.998 8.83008 8.71289 11.1152 5.87695 11.1152ZM5.88281 8.26172C7.13086 8.26172 8.14453 7.24805 8.14453 5.99414C8.14453 4.74023 7.13086 3.72656 5.88281 3.72656C4.62305 3.72656 3.60938 4.74023 3.60938 5.99414C3.60938 7.24805 4.62305 8.26172 5.88281 8.26172Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.898fe8fca47aed57f373d534d9d2cec8.svg";
export { ForwardRef as ReactComponent };